import {delay } from "redux-saga";
import { call, put, select } from "redux-saga/effects";
import {getPaymentReminderSuccess,getPaymentReminderError,updatePaymentReminderSucess,updatePaymentReminderError,togglePaymentReminderSucess,togglePaymentReminderError,deletePaymentReminderSucess,deletePaymentReminderError
 } from "../actions/payReminder.js";
 import { getUserInfoSelector } from "../selectors/paymentsSelectors";

 import { ClaroSDKService } from "../../services/sdk/ClaroSDKService";

 
export function* getPaymentReminder() {
    try {
      const userInfo = yield select(getUserInfoSelector);
  
      const responseGetPaymentReminder = yield call(ClaroSDKService.getPaymentReminder, userInfo);
      yield delay(400);
      yield put(getPaymentReminderSuccess(responseGetPaymentReminder));
      
    } catch (error) {
      yield put(getPaymentReminderError(error));
    }
  }
  
  export function* updatePaymentReminder(action) {
    try {
      const userInfo = yield select(getUserInfoSelector);
      const { alias,idReminder,serviceId } = action.action;
      const request = {
        alias,idReminder,serviceId,
        userInfo: userInfo, 
      };
  
      const responseUpdatePaymentReminder = yield call(ClaroSDKService.updatePaymentReminder, request);
      yield delay(400);
      yield put(updatePaymentReminderSucess(responseUpdatePaymentReminder));
      
    } catch (error) {
      yield put(updatePaymentReminderError(error));
    }
  }
  
  export function* togglePaymentReminder(action) {
    try {
      const userInfo = yield select(getUserInfoSelector);
      const {active,idReminder,serviceId} = action.action;
      const request = {
        active:active,
        userInfo:userInfo,
        idReminder:idReminder,
        serviceId:serviceId 
      };
     
      const responseTogglePaymentReminder = yield call(ClaroSDKService.togglePaymentReminder, request);
      yield delay(400);
      yield put(togglePaymentReminderSucess(responseTogglePaymentReminder));
      
    } catch (error) {
      yield put(togglePaymentReminderError(error));
    }
  }
  
  export function* deletePaymentReminder(action) {
    try {
      const responseDeletePaymentReminder = yield call(ClaroSDKService.deletePaymentReminder, action.idReminder);
      yield delay(400);
      yield put(deletePaymentReminderSucess(responseDeletePaymentReminder));
      
    } catch (error) {
      yield put(deletePaymentReminderError(error));
    }
  }